export default __webpack_public_path__ + "static/media/buffalo2.9e51dcd2.png";